"use client";

import { useSearch } from "@/context/SearchContext";
import Image from "next/image";
import ClearIcon from "./images/clear.svg";
import SearchIcon from "./images/input-search.svg";

interface SearchInputProps {
  searchHelper: string;
}

export default function SearchInput({ searchHelper }: SearchInputProps) {
  const { search, currentSearchTerm, slug, setSearchResult, resetFilters } =
    useSearch();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const term = formData.get("search") as string;

    if (term?.trim()) {
      window.history.replaceState(
        null,
        "",
        `/${slug}?term=${encodeURIComponent(term)}`
      );
      search(term, {}, true);
    } else {
      window.history.replaceState(null, "", `/${slug}`);
      setSearchResult(null);
    }
  };

  const onClear = (form: HTMLFormElement) => {
    form.reset();
    setSearchResult(null);
    resetFilters();
    window.history.replaceState(null, "", `/${slug}`);
  };

  return (
    <form onSubmit={handleSubmit} className="input-container-wrapper">
      <div className="input-container">
        <label htmlFor="searchInput" className="visually-hidden">
          Search
        </label>
        <input
          name="search"
          id="searchInput"
          type="text"
          placeholder={searchHelper}
          defaultValue={currentSearchTerm ?? ""}
        />
        <button
          type="button"
          id="clearButton"
          onClick={(e) => onClear(e.currentTarget.form!)}
          aria-label="Button for clearing input field"
        >
          <Image id="clearIcon" src={ClearIcon} alt="" width={24} height={24} />
        </button>
      </div>
      <div id="searchButtonWrapper">
        <button
          type="submit"
          name="search button"
          id="searchButton"
          aria-label="Click to search"
        >
          <Image
            id="searchButtonIcon"
            src={SearchIcon}
            alt=""
            fill
          />
        </button>
      </div>
    </form>
  );
}
